

































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";

// Types
import { IContract, IContractProduct } from "@/models/contracts";
import Context from "@/mixins/context";

@Component({
  components: {
    "cprod-provider": () =>
      import("@/components/app/global/contractProducts/cProdProvider.vue"),
    "cprod-prov-provider": () =>
      import("@/components/app/global/contractProducts/cProdProvProvider.vue"),
    "cprod-well-link": () =>
      import(`@/components/app/global/contractProducts/cProdWellLink.vue`),
    "cprod-breakdown": () =>
      import(`@/components/app/global/contractProducts/cProdBreakdown.vue`),
    "cprod-timeline": () =>
      import(`@/components/app/global/contractProducts/cProdTimeline.vue`),
    "cprod-messages": () =>
      import(`@/components/app/global/contractProducts/cProdMessages.vue`),
    "cprod-details-table": () =>
      import(`@/components/app/global/contractProducts/cProdDetailsTable.vue`),
    "cprod-provision-actions": () =>
      import("@/components/app/global/contractProducts/cProdProvActions.vue"),
    "cprod-prov-config": () =>
      import("@/components/app/global/contractProducts/cProdProvConfig.vue"),
    "cprod-prov-config-manage-form": () =>
      import(
        "@/components/app/global/contractProducts/cProdProvConfigManageForm.vue"
      ),
    "cprod-prov-requests-table": () =>
      import(
        "@/components/app/global/contractProducts/cProdProvRequestsTable.vue"
      ),
    "cprod-notes-component": () =>
      import("@/components/app/global/contractProducts/cProdNotesComp.vue"),
    "cprod-secrets-component": () =>
      import("@/components/app/global/contractProducts/cProdSecretsComp.vue")
  }
})
export default class CProdQuickLookModal extends Mixins(Context) {
  // Refs

  public declare $refs: {
    observer: InstanceType<typeof ValidationObserver>;
    manageConfigurationForm: any;
  };

  // Props

  @Prop({ required: true })
  public contractId!: IContract["id"];

  @Prop({ default: null })
  public productId!: IContractProduct["id"];

  @Prop({ default: null })
  public productOptionId!: IContractProduct["id"];

  @Prop({ default: null })
  public productAttributeId!: IContractProduct["id"];

  @Prop({ required: true })
  public cProdIdentifier!: string;

  // Data
  public isEnabled = false;
  public isProcessing = false;

  // Computed

  public get cProdIds() {
    return {
      contractId: this.contractId,
      productId: this.productId,
      productOptionId: this.productOptionId,
      productAttributeId: this.productAttributeId
    };
  }

  public getGroupedActions(cProdData) {
    return [...cProdData.billingActions, ...cProdData.productActions];
  }

  // Methods

  public async validateBeforeSubmit() {
    this.$refs["manageConfigurationForm"].validateBeforeSubmit();
  }

  public async revertToInitialState() {
    this.$refs["manageConfigurationForm"].revertToInitialState();
  }
}
